// extracted by mini-css-extract-plugin
export default {"modify_order_header":"ty","center":"uy","empty":"vy","pending":"wy","referralTitle":"xy","wrapper":"yy","title":"zy","tabs":"Ay","tab":"By","active":"Cy","btn":"Ey","rewards_table":"Fy"};
    if(module.hot) {
      // 1715188235778
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  